export default __webpack_public_path__ + "static/media/69t.962a645a.jpg";